/**
 * Posts TanStack query key factory — keep in sync with posts.query-store usage.
 */
export const postsQueryKeys = {
  all: (gId?: string) => ['posts', gId] as const,
  single: (postId?: string, groupId?: string, locationId?: string) => ['posts', 'single', postId, groupId, locationId] as const,
  infinitePublicPosts: (gId?: string) => ['posts', gId, 'public', 'infinite'] as const,
  infiniteChannelPosts: (gId?: string, channelId?: string) => ['posts', gId, 'channel', channelId, 'infinite'] as const,
  infiniteChannelPinnedPosts: (gId?: string, channelId?: string) => ['posts', gId, 'channel', channelId, 'pinned', 'infinite'] as const,
  infiniteHomePinnedPosts: (gId?: string) => ['posts', gId, 'home-pinned', 'infinite'] as const,
  infiniteUserPosts: (gId?: string, contactId?: string) => ['posts', gId, 'user', contactId, 'infinite'] as const,
} as const
